import { LogoDataStone } from "@/components/atoms/LogoDataStone";

export const Footer = () => {
  const FooterElement = document.createElement("div");
  FooterElement.className =
    "mx-auto w-full max-w-[calc(100%_-_2rem)] flex flex-col gap-2 items-center";

  FooterElement.appendChild(LogoDataStone());

  const currentYear = new Date().getFullYear();
  FooterElement.innerHTML += /* html */ `
        <p class="text-gray-400 text-base px-2 text-center">
            Data Stone. Todos os direitos reservados. © ${currentYear}
        </p>
    `;

  return FooterElement;
};
